var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 45.75C33.0355 45.75 33.875 44.9105 33.875 43.875C33.875 42.8395 33.0355 42 32 42C30.9645 42 30.125 42.8395 30.125 43.875C30.125 44.9105 30.9645 45.75 32 45.75Z",
    fill: "#0256B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.25 26.5614C43.6682 22.8037 37.9257 20.75 32 20.75C26.0743 20.75 20.3318 22.8037 15.75 26.5614",
    stroke: "#0256B8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.25 32.1562C40.048 29.6214 36.0839 28.2422 32 28.2422C27.9161 28.2422 23.952 29.6214 20.75 32.1562",
    stroke: "#0256B8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 37.7827C36.4338 36.4616 34.2458 35.75 32 35.75C29.7542 35.75 27.5662 36.4616 25.75 37.7827",
    stroke: "#0256B8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon12.551a03adce71cbd4ae6269ae083eb3f7.svg";
export { ForwardRef as ReactComponent };